import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import { FormattedDate, FormattedTime } from 'react-intl'
import BookingInfoModal from 'components/AvailabilityDataTable/components/BookingInfoModal'

const MyBookingsWidget = ({widget}) => {
  const mounted = useRef(false);
  
  const [bookings, setBookings] = useState([]);
  const [title, setTitle] = useState('');
  const [showBookingInfoModal, setShowBookingInfoModal] = useState(false)
  const [modalBookingId, setModalBookingId] = useState(null)

  useEffect(() => {
    mounted.current = true;
    fetch('coordinatordashboard/My_Bookings')
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setBookings(data.data.bookings);
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      mounted.current = false;
    };
  }, [])

  useEffect(() => {
    if (modalBookingId) {
      setShowBookingInfoModal(true)
    }
  }, [modalBookingId])

  const getStartDate = (booking) => {
    const value = new Date(booking["dateStart"] * 1000)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const getEndDate = (booking) => {
    const value = new Date(booking["dateEnd"] * 1000)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const widget_id = `ID_${widget.widgetId}`;
  
  return (
    <div className="bg-white border shadow rounded border-gray-400" id={widget_id}>
      <WidgetHeader widget={widget} widgetTitle={title} />

      <table className="w-full table-fixed text-xs">
        <thead>
          <tr>
            <td className="border-b p-2 w-2/12">Supplier</td>
            <td className="border-b p-2 w-3/12">From</td>
            <td className="border-b p-2 w-3/12">To</td>
            <td className="border-b p-2 w-3/12">Message</td>
            <td className="border-b p-2 w-1/12"></td>
          </tr>
        </thead>

        <tbody>
          {bookings.map((booking, i) => (
            <tr key={i} title={booking['message']} className="hover:bg-gray-200 dataRow cursor-pointer" onClick={() => setModalBookingId(booking['uid'])} >
              <td className="border-b p2 w-3/12">{booking['username']}</td>
              <td className="border-b p2 w-3/12">{getStartDate(booking)}</td>
              <td className="border-b p2 w-3/12">{getEndDate(booking)}</td>
              <td className="border-b p-2 w-3/12 truncate">
                  {booking['message']}
              </td>
              <td className="border-b p-2 w-1/12">
                {
                  booking['accepted'] == 1 ? (<i className="block rounded-full w-2 h-2 bg-green-500" title="Accepted"/>)
                  : booking['rejected'] == 1 ? (<i className="block rounded-full w-2 h-2 bg-red-600" title="Rejected"/>)
                  : (<i className="block rounded-full w-2 h-2 bg-yellow-500" title="Pending"/>)
                }
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <BookingInfoModal show={showBookingInfoModal} bookingId={modalBookingId} onClose={() => setShowBookingInfoModal(false)} />
    </div>
  );

}

export default MyBookingsWidget;
